export const customListOwnershipsFields = [{
        name: "name",
        title: "Nome"
    }, {
        name: "pathFattureDaSpedire",
        title: "Percorso fatture da spedire",
        render: (x) => x.pathFattureDaSpedire == null ? "" : x.pathFattureDaSpedire
    }, {
        name: "pathFattureDaArchiviare",
        title: "Percorso fatture da archiviare",
        render: (x) => x.pathFattureDaArchiviare == null ? "" : x.pathFattureDaArchiviare
    }, {
        name: "emailMittente",
        title: "Email mittente",
        render: (x) => x.emailMittente == null ? "" : x.emailMittente
    }, {
        name: "pecMittente",
        title: "PEC mittente",
        render: (x) => x.pecMittente == null ? "" : x.pecMittente
    }];
